<template>
  <div class="dashboard">
    <!-- Sidebar -->
    <Sidebar :open="isSidebarExpanded" @toggle="handleSidebarToggle" />

    <!-- Spacer + main row -->
    <div class="content-row">
      <div
        class="sidebar-spacer"
        :style="{ width: isSidebarExpanded ? '250px' : '60px' }"
      ></div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Header -->
      <header>
        <div class="header-left">
          <i class="fas fa-bars" @click="handleSidebarToggle"></i>
          <WaitingDriversNumber :waiting-captains="waitingCaptains" />
        </div>
        <div class="header-right"></div>
      </header>

      <!-- Body -->
      <div class="users-list">
        <div class="users-header"></div>

        <!-- ====== Form إضافة / تعديل Region ====== -->
        <div class="card">
          <h3>Regions management</h3>

          <form @submit.prevent="saveRegion">
            <div class="grid">
              <!-- Region Name -->
              <div class="field">
                <label> Region (المحافظة)</label>
                <input
                  v-model.trim="form.regionName"
                  list="regions-list"
                  placeholder="مثال: cairo governorate"
                  required
                />
                <datalist id="regions-list">
                  <option v-for="r in suggestedRegions" :key="r" :value="r" />
                </datalist>
              </div>

              <!-- Active / Inactive -->
              <div class="field">
                <label> State </label>
                <select v-model="form.isActive">
                  <option :value="true">Active</option>
                  <option :value="false">Inactive</option>
                </select>
              </div>

              <!-- ✅ تشيك بوكس لتفعيل الريوارد -->
              <div class="field col-span-2 checkbox-row">
                <input type="checkbox" v-model="form.hasReward" />
                <label> Reward </label>
              </div>

              <!-- ✅ الحقول الأربعة تظهر فقط لو hasReward = true -->
              <template v-if="form.hasReward">
                <div class="field">
                  <label> Strat date of offer share </label>
                  <input
                    type="date"
                    v-model="form.reward.startDate"
                    :min="today"
                  />
                </div>

                <div class="field">
                  <label> End date of offer share</label>
                  <input
                    type="date"
                    v-model="form.reward.endDate"
                    :min="form.reward.startDate || today"
                  />
                </div>

                <div class="field">
                  <label>Trip Count (عدد الرحلات)</label>
                  <input
                    type="number"
                    min="1"
                    v-model.number="form.reward.tripCount"
                    placeholder="10"
                  />
                </div>

                <div class="field">
                  <label>Reward Value (قيمة البونص)</label>
                  <input
                    type="number"
                    min="1"
                    v-model.number="form.reward.rewardValue"
                    placeholder="30"
                  />
                </div>
                <div class="field">
                  <label>Reward Unique ID</label>
                  <input
                    type="text"
                    v-model.trim="form.reward.uniqueId"
                    placeholder="مثال: 44F أو S44"
                  />
                </div>
              </template>

              <!-- Actions -->
              <div class="actions col-span-2">
                <button type="submit" :disabled="loading">
                  <span v-if="!loading">
                    {{ editingName ? "تحديث المنطقة" : " Save Region" }}
                  </span>
                  <span v-else>جاري الحفظ...</span>
                </button>

                <button
                  type="button"
                  class="secondary"
                  @click="resetForm"
                  :disabled="loading"
                >
                  تفريغ الحقول
                </button>
              </div>
            </div>
          </form>

          <div v-if="feedback.message" class="toast" :class="feedback.type">
            {{ feedback.message }}
          </div>
        </div>

        <!-- ====== جدول كل المناطق ====== -->
        <div class="card">
          <h3>Active Regions</h3>

          <button
            class="secondary"
            @click="fetchActiveRegions"
            :disabled="loading"
          >
            Active Regions
          </button>

          <div
            v-if="activeRegions.length === 0"
            class="muted"
            style="margin-top: 10px"
          >
            لا توجد مناطق مضافة بعد.
          </div>

          <table v-else class="table" style="margin-top: 12px">
            <thead>
              <tr>
                <th>Regions</th>
                <th>State</th>
                <th>Start</th>
                <th>End</th>
                <th>Trip Count</th>
                <th>Reward Value</th>
                <th>Users</th>
                <th>Captains</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in activeRegions" :key="r._id">
                <td>{{ r.regionName }}</td>
                <td>{{ r.isActive ? "Active" : "Inactive" }}</td>
                <td>{{ r.reward?.startDate || "-" }}</td>
                <td>{{ r.reward?.endDate || "-" }}</td>
                <td>
                  {{
                    r.reward?.rewards?.length
                      ? r.reward.rewards[0].tripCount
                      : "-"
                  }}
                </td>

                <td>
                  {{
                    r.reward?.rewards?.length
                      ? r.reward.rewards[0].rewardValue
                      : "-"
                  }}
                </td>
                <td>{{ r.usersCount != null ? r.usersCount : "-" }}</td>
                <td>{{ r.captainsCount != null ? r.captainsCount : "-" }}</td>
                <td class="table-actions">
                  <button
                    type="button"
                    class="secondary"
                    @click="fillFormFromRegion(r)"
                  >
                    Edit
                  </button>
                  <button type="button" class="danger" @click="deleteRegion(r)">
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="muted" style="margin-top: 6px">
            Users / Captains هتتعبي تلقائيًا لو الـ API رجّع
            <code>usersCount</code> و <code>captainsCount</code> لكل منطقة.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import Sidebar from "./sidebarComponent.vue";
import WaitingDriversNumber from "@/components/waitingDriversNumber.vue";

export default {
  name: "ActiveRegionsView",
  components: { Sidebar, WaitingDriversNumber },
  data() {
    return {
      isSidebarExpanded: true,
      waitingCaptains: 0,
      today: new Date().toISOString().split("T")[0],

      API_BASE: "https://backend.fego-rides.com",
      loading: false,

      form: {
        regionName: "",
        isActive: true,
        hasReward: false,
        reward: {
          startDate: "",
          endDate: "",
          tripCount: null,
          rewardValue: null,
          uniqueId: "",
        },
      },
      editingName: null,

      activeRegions: [],
      suggestedRegions: [],
      feedback: { message: "", type: "info" },
    };
  },
  methods: {
    handleSidebarToggle() {
      this.isSidebarExpanded = !this.isSidebarExpanded;
    },

    buildHeaders() {
      const token =
        localStorage.getItem("admin_token") ||
        localStorage.getItem("token") ||
        "";
      const headers = { "Content-Type": "application/json" };
      if (token) headers["Authorization"] = `Bearer ${token}`;
      return headers;
    },

    toast(message, type = "info") {
      this.feedback = { message, type };
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(
        () => (this.feedback = { message: "", type: "info" }),
        4000
      );
    },

    resetForm() {
      this.form = {
        regionName: "",
        isActive: true,
        hasReward: false,
        reward: {
          startDate: "",
          endDate: "",
          tripCount: null,
          rewardValue: null,
          uniqueId: "",
        },
      };
      this.editingName = null;
      this.feedback = { message: "", type: "info" };
    },

    // payload للـ API
    buildPayload() {
      const base = {
        regionName: this.form.regionName,
        isActive: this.form.isActive,
      };

      if (this.form.hasReward) {
        const r = this.form.reward;
        base.reward = {
          startDate: r.startDate,
          endDate: r.endDate,
          rewards: [
            {
              tripCount: r.tripCount,
              rewardValue: r.rewardValue,
              uniqueId: r.uniqueId,
            },
          ],
        };
      }

      return base;
    },

    async saveRegion() {
      if (!this.form.regionName) {
        this.toast("من فضلك اكتب اسم المنطقة.", "error");
        return;
      }

      // ✅ لو activate reward لازم الأربع قيم
      if (this.form.hasReward) {
        const r = this.form.reward;

        if (!r.startDate || !r.endDate) {
          this.toast(
            "لو هتفعّلي Reward لازم تكتبي تاريخ البداية وتاريخ النهاية.",
            "error"
          );
          return;
        }

        if (!r.tripCount || !r.rewardValue) {
          this.toast(
            "لو هتفعّلي Reward لازم تدخلي Trip Count و Reward Value.",
            "error"
          );
          return;
        }
        if (!r.uniqueId) {
          this.toast("لو هتفعّلي Reward لازم تحطي Unique ID للعرض.", "error");
          return;
        }
      }

      this.loading = true;
      this.toast("جارٍ حفظ البيانات...", "info");

      try {
        const payload = this.buildPayload();

        await axios.post(`${this.API_BASE}/active-region/add`, payload, {
          headers: this.buildHeaders(),
        });

        this.toast("تم حفظ المنطقة بنجاح ✅", "success");
        this.resetForm();
        this.fetchActiveRegions();
      } catch (err) {
        console.error(err);
        const msg =
          err?.response?.data?.message || err?.message || "حدث خطأ أثناء الحفظ";
        this.toast(msg, "error");
      } finally {
        this.loading = false;
      }
    },

    fillFormFromRegion(region) {
      this.editingName = region.regionName || null;
      this.form.regionName = region.regionName;
      this.form.isActive = !!region.isActive;

      const hasReward =
        region.reward &&
        region.reward.rewards &&
        region.reward.rewards.length > 0;

      this.form.hasReward = !!hasReward;

      if (hasReward) {
        const first = region.reward.rewards[0];
        this.form.reward = {
          startDate: region.reward.startDate || "",
          endDate: region.reward.endDate || "",
          tripCount: first.tripCount || null,
          rewardValue: first.rewardValue || null,
          uniqueId: first.uniqueId || "",
        };
      } else {
        this.form.reward = {
          startDate: "",
          endDate: "",
          tripCount: null,
          rewardValue: null,
        };
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async deleteRegion(region) {
      if (!region._id) {
        this.toast("لا يمكن حذف الـ Region لأن الـ id غير معروف.", "error");
        return;
      }

      if (!confirm(`متأكدة إنك عايزة تمسحي المنطقة: ${region.regionName} ؟`)) {
        return;
      }

      this.loading = true;
      this.toast("جارٍ حذف المنطقة...", "info");

      try {
        await axios.delete(`${this.API_BASE}/active-region/${region._id}`, {
          headers: this.buildHeaders(),
        });

        this.toast("تم حذف المنطقة بنجاح ✅", "success");
        this.fetchActiveRegions();
      } catch (err) {
        console.error(err);
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "حدث خطأ أثناء حذف المنطقة";
        this.toast(msg, "error");
      } finally {
        this.loading = false;
      }
    },

    async fetchActiveRegions() {
      try {
        // 1) هاتِ كل الـ regions (مع الريواردز والحالة)
        const regionsRes = await axios.get(
          `${this.API_BASE}/active-region/all`,
          {
            headers: this.buildHeaders(),
          }
        );
        const regions = regionsRes.data || [];

        // 2) هاتِ عدّاد اليوزرز والكباتن لكل محافظة
        const countsRes = await axios.get(
          `${this.API_BASE}/admin/getActiveRegionsWithUsersAndDriversCount`,
          { headers: this.buildHeaders() }
        );
        const countsMap = countsRes.data || {}; // ده Object: { "cairo governorate": { users, drivers }, ... }

        // 3) دمج الاتنين: نزود على كل region الأعداد بتاعته لو موجودة
        this.activeRegions = regions.map((r) => {
          const key = r.regionName; // لازم يكون نفس الاسم اللي راجع من الـ counts
          const counts = countsMap[key] || {};
          return {
            ...r,
            usersCount: counts.users ?? null,
            captainsCount: counts.drivers ?? null, // اسمها drivers في الـ backend
          };
        });
      } catch (err) {
        console.error(err);
        this.toast("تعذر تحميل المناطق أو الأعداد.", "error");
      }
    },

    async fetchSuggestedRegions() {
      try {
        const res = await axios.get(
          `${this.API_BASE}/active-region/suggested`,
          { headers: this.buildHeaders() }
        );
        this.suggestedRegions = res.data?.regions || [];
      } catch (err) {
        console.error(err);
      }
    },
  },
  mounted() {
    this.fetchActiveRegions();
    this.fetchSuggestedRegions();
  },
};
</script>

<style scoped>
:root {
  --sidebar-width: 250px;
  --sidebar-collapsed: 60px;
}

.dashboard {
  display: block;
}

.content-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.sidebar-spacer {
  flex: 0 0 auto;
  transition: width 0.3s ease;
}

.main-content {
  flex: 1 1 auto;
  min-width: 0;
  padding: 16px;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

@media (max-width: 720px) {
  .sidebar-spacer {
    width: 0 !important;
  }
  .main-content {
    max-width: 100%;
    margin: 0;
  }
}

.card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  margin: 12px 0;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
}

.col-span-2 {
  grid-column: span 2;
}

.field label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
}

.field select,
.field input,
.field textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
}

.checkbox-inline {
  display: flex;
  align-items: center;
  gap: 6px;
}

.actions {
  display: flex;
  justify-content: center; /* ← وسط */
  gap: 15px;
  margin-top: 10px;
}

button {
  border: 0;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  background: #965edb;
  color: #fff;
  font-weight: 600;
}

button.secondary {
  background: #e5e7eb;
  color: #111827;
}

button.danger {
  background: #fecaca;
  color: #7f1d1d;
}

.toast {
  padding: 12px 14px;
  border-radius: 12px;
  margin: 12px 0;
  font-weight: 600;
}

.toast.info {
  background: #eff6ff;
  color: #1e40af;
}

.toast.success {
  background: #ecfdf5;
  color: #065f46;
}

.toast.error {
  background: #fef2f2;
  color: #991b1b;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table th,
.table td {
  border-bottom: 1px solid #f3f4f6;
  padding: 10px 8px;
  text-align: left;
  vertical-align: top;
}

.table-actions {
  display: flex;
  gap: 6px;
}

.muted {
  color: #6b7280;
  font-size: 13px;
}
.checkbox-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.checkbox-row input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.checkbox-row label {
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 720px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
